import React from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { fonts } from "theme/fonts";

export const Main = ({ children, noPadding, subHeading, body }) => {
  let showMainContainer = false;
  if (subHeading || body) showMainContainer = true;

  return (
    <MainWrapper id="main">
      {showMainContainer && (
        <MainContainer noPadding={noPadding}>
          {subHeading && (
            <SubheadingContent>{ReactHtmlParser(subHeading)}</SubheadingContent>
          )}
          {body && (
            <BodySection>
              <p>{ReactHtmlParser(body)}</p>
            </BodySection>
          )}
        </MainContainer>
      )}
      {!!children && children}
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MainContainer = styled.div`
  padding: ${(props) => (props.noPadding ? 0 : "35px 15px")};
  text-align: center;
`;

const SubheadingContent = styled.h4`
  font-size: clamp(24px, 3vw, 32px);
  margin: 0 0 16px;
  text-transform: uppercase;
`;

const BodySection = styled.div`
  font-size: 18px;
  max-width: 900px;
  margin: 0 auto;

  p {
    font-family: ${fonts.secondary};
    font-weight: 300;
    margin-top: 0;
  }
`;
